import dedent from 'dedent';

export const termsOfServiceDef = {
  text: dedent`Last Updated 6 Oct 2024
Terms of Services
Please read and understand our Terms of Service carefully before using our Services.

1. Acceptance of Terms
By accessing or using Waterlily’s eldercare planning services (the “Services”), you agree to comply with and be bound by these Terms of Service (“Terms”) and our Privacy Policy, which govern your access and use of the Services. We may update these Terms from time to time. If we make material changes, we will notify you by email or through a notice on our Services. It is your responsibility to review these Terms and the Privacy Policy periodically to be aware of any modifications.



2. Ownership and Limited License
The Services, including all text, graphics, images, and other content, are owned by Waterlily or our licensors and are protected under United States and foreign laws. Waterlily retains all rights not expressly granted to you herein. You are granted a limited, nonexclusive, nontransferable, non-sublicensable, revocable license to access and use our Services as permitted under these Terms.



3. Trademarks
The Waterlily name, logos, slogans, and look and feel are trademarks of Waterlily and may not be used without prior written permission.



4. Feedback
Any feedback you provide regarding the Services is voluntary and appreciated. By submitting feedback, you grant Waterlily a non-exclusive, royalty-free license to use, reproduce, and incorporate your feedback into the Services or other products.



5. Personal Information
Waterlily will process personal information as necessary to provide and improve the Services or comply with the law. If you provide personal information about others, you warrant that you are authorized to disclose such information and that all such disclosure complies with applicable laws and regulations.


6. Restrictions
You shall not:

Decompile, reverse engineer, disassemble, or otherwise attempt to derive the source code of the Services.

Modify, translate, or create derivative works based on the Services.

Use the Services for any unlawful purpose or in violation of any applicable laws or regulations.



Acknowledgement of Non-Responsibility:

You acknowledge that Waterlily does not undertake and is not responsible for any insurance or financial product recommendations that might be made to consumers. You release Waterlily from any actual or alleged liability related to insurance or financial product recommendations directed to any consumer or purchaser of a financial or insurance product, regardless of whether Waterlily products are used in making any such recommendation.



7. Disclaimers
Waterlily strives to provide accurate health projections, financial product and policy extraction, modeling, and calculation services but provides them "as is," without warranties, express or implied, and disclaims responsibility for any inaccuracies. You are solely responsible for verifying and correcting any extracted product information and calculations against original product documentation, and to review the Disclaimers and Disclosures and Methodology to understand how any health predictions and financial projections are made, and how to interpret them.



8. Limitation of Liability
To the maximum extent permitted by law, in no event shall Waterlily be liable for any indirect, incidental, consequential, special, or exemplary damages arising out of or in connection with your use of the Services, except in cases of gross negligence or willful misconduct.



9. Indemnification
You agree to indemnify, defend, and hold harmless Waterlily and its directors, officers, employees, and agents from and against any claims, liabilities, damages, losses, and expenses, including without limitation reasonable legal and accounting fees, arising out of or in any way connected with:

Your access to or use of the Services.

Your violation of these Terms.

Your violation of any applicable laws or regulations.



10. Compliance with Laws
You represent and warrant that you will use the Services in compliance with all applicable laws and regulations, including those related to financial planning, insurance, securities, marketing, privacy, and data security.



11. Modifications to Services
While we will endeavor to provide reasonable notice before significant changes, Waterlily reserves the right to modify or discontinue, temporarily or permanently, the Services (or any part thereof) with or without notice. You agree that Waterlily shall not be liable to you or to any third party for any modification, suspension, or discontinuance of the Services.



12. Termination
Waterlily may terminate or suspend your access to the Services immediately if you breach these Terms or engage in unlawful activities. Upon termination, your right to use the Services will cease.



13. Governing Law
These Terms shall be governed and construed in accordance with the laws of the State of Nevada, without regard to its conflict of law provisions. You agree to comply with all local laws applicable to your use of the Services.



14. Severability
If any provision of these Terms is held to be invalid or unenforceable, the remaining provisions will remain in full force and effect.



15. Contact Us
If you have any questions about these Terms, please contact us at hello@joinwaterlily.com.


Last Updated
October 6th, 2024`,
  date: '2024-10-07',
  consentVersionDescription: 'Terms Of Services - Updated 6 October 2024',
};
